import { queryOptions, useQuery } from '@tanstack/react-query'
import { useUserId } from '@/features/account/services/User/hooks'
import { fetchCreditDetails } from '@/features/purchase/services/Wallet/fetchers'

export const creditDetailsQueryOptions = queryOptions({
  queryKey: ['Credit Details'] as const,
  queryFn: fetchCreditDetails,
})

export const useQueryCreditDetails = () => {
  const user_id = useUserId() ?? 0
  return useQuery({
    ...creditDetailsQueryOptions,
    enabled: Boolean(user_id),
  })
}
